import { useIsCompact } from '../app/media'
import { useStrings } from '../i18n'
import { Legend } from '../legend/Legend'
import { selectSelectedSiteId, useAppStore } from '../state/store'
import { DetailEmpty } from './DetailStates'
import { SiteDetailPanel } from './SiteDetailPanel'
import './detail.css'

/**
 * What fills the detail rail.
 *
 * On a wide screen the rail carries two things: the selected site, and the
 * legend. The legend lives here rather than over the map because it is reference
 * material - it belongs beside the reading surface, not on top of the thing
 * being read.
 *
 * On a narrow screen the rail is not a rail: the site becomes a bottom sheet
 * that appears when something is selected, and the legend moves into the filter
 * sheet, where it can be reached before a selection rather than only after one.
 * It is mounted in exactly one of the two places at a time.
 */
export const DetailSlot = () => {
  const strings = useStrings()
  const compact = useIsCompact()
  const selectedSiteId = useAppStore(selectSelectedSiteId)

  // On a phone with nothing selected this region would be an empty landmark
  // with a heading and no content - something a screen reader announces and a
  // sighted visitor never sees. There is nothing to say, so it says nothing.
  if (compact && selectedSiteId === null) return null

  return (
    <section className="ev-rail" aria-label={strings.detail.title}>
      <h2 className="visually-hidden">{strings.detail.title}</h2>

      {selectedSiteId === null ? !compact && <DetailEmpty /> : <SiteDetailPanel />}

      {!compact && <Legend />}
    </section>
  )
}

export { SiteDetailPanel } from './SiteDetailPanel'
export { MethodologyModal } from './voltage/MethodologyModal'
